import { render, staticRenderFns } from "./ScheduledMassMessageStatItem.vue?vue&type=template&id=0f914ca2&scoped=true&"
import script from "./ScheduledMassMessageStatItem.vue?vue&type=script&lang=ts&"
export * from "./ScheduledMassMessageStatItem.vue?vue&type=script&lang=ts&"
import style0 from "./ScheduledMassMessageStatItem.vue?vue&type=style&index=0&id=0f914ca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f914ca2",
  null
  
)

export default component.exports